import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '../helpers/ApiClient';

export const productGroupService = {
    getProductGroups,
    updateProductGroup,
    addProductGroup,
    deleteProductGroup,
    updateProductsOrderIndex,
    updateProductsGroupBatch,
    deleteProductGroupBatch
}

function getProductGroups(boolean) {
    return apiClient.get(`/product_group?with_product_data=${boolean}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function updateProductGroup(productGroup) {
    return apiClient.patch(`/product_group/${productGroup.productGroupId}`, productGroup, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function addProductGroup(productGroup) {
    return apiClient.post(`/product_group`, productGroup, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteProductGroup(productGroup) {
    return apiClient.delete(`/product_group/${productGroup.productGroupId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));  
}

function deleteProductGroupBatch(productGroupIds){
    return apiClient.delete(`/product_group`, {
        headers: authHeader(),
        data: productGroupIds
    })
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function updateProductsOrderIndex(payload){
    return apiClient.patch(`/product_group/order`, payload, {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}

function updateProductsGroupBatch(productGroups){
    return apiClient.post(`/product_group/batch`, productGroups, {headers: authHeader()})
        .then((response) => { return response.data})
        .catch((error) => handleError(error));
}
